/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MasterAccountDetails extends models.MasterAccountBase {
    getFixupPrototypeFunction() { return MasterAccountDetails.fixupPrototype; }

    static newInstance(model: Partial<MasterAccountDetails>): MasterAccountDetails {
        let obj = Object.assign(new MasterAccountDetails(), model);
        MasterAccountDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MasterAccountDetails>): MasterAccountDetails {
        if (!model) return null;
        return MasterAccountDetails.newInstance(<MasterAccountDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MasterAccountDetails) {
        if (!obj) return;

        models.MasterAccountDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MasterAccountDetails): boolean {
        if (models.MasterAccountBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, MasterAccountDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (this.cost_anomaly_settings) {
            models.CostAnomalyConfiguration.fixupPrototype(this.cost_anomaly_settings);
        }
        if (this.cost_processing_settings) {
            models.CostProcessingSettings.fixupPrototype(this.cost_processing_settings);
        }
        if (this.nextgen_report_settings) {
            models.NextgenReportSettings.fixupPrototype(this.nextgen_report_settings);
        }
        if (this.scim_settings) {
            models.MasterAccountScimSettings.fixupPrototype(this.scim_settings);
        }
        if (this.auth_config) {
            for (let val of this.auth_config) {
                models.MasterAccountAuthConfig.fixupPrototype(val);
            }
        }
        if (this.cost_recommendation_settings) {
            for (let val of this.cost_recommendation_settings) {
                models.MasterAccountCostRecommendationSettings.fixupPrototype(val);
            }
        }
    }

    /**
     * Master account status
     */
    status: string;

    /**
     * Name of the user created this master account.
     */
    created_by: string;

    /**
     * Name of the user last updated this master account.
     */
    updated_by: string;

    /**
     * DateTime in UTC when the master account was last updated.
     */
    updated_at: Date;

    /**
     * DateTime in UTC when the master account was created.
     */
    created_at: Date;

    /**
     * Auth Configuration
     */
    auth_config: Array<models.MasterAccountAuthConfig>;

    /**
     * Checks if the account is mcp server enabled or not
     */
    mcp_server_enabled: boolean;

    /**
     * Checks if the account is graphdb sync enabled or not
     */
    graphdb_sync_enabled: boolean;

    /**
     * Checks if the accounts automation workflow configuration has enabled or not
     */
    automation_workflow_enabled: boolean;

    /**
     * Whether the TokenOps feature (menu, dashboard, and Anthropic/Bedrock AI usage ingestion) is enabled for this master account
     */
    tokenops_enabled: boolean;

    cost_anomaly_settings: models.CostAnomalyConfiguration;

    cost_recommendation_settings: Array<models.MasterAccountCostRecommendationSettings>;

    /**
     * Flag to enable dimension precomputation for this master account
     */
    dimension_pre_computation_enabled: boolean;

    /**
     * Flag to enable Azure CSP Partner account discovery for this master account
     */
    discover_azure_csp_partner_accounts: boolean;

    /**
     * Flag to enable Savings Plans utilization and recommendations for member accounts under this master account
     */
    savings_plan_for_aws_member_accounts_enabled: boolean;

    cost_processing_settings: models.CostProcessingSettings;

    nextgen_report_settings: models.NextgenReportSettings;

    /**
     * Account owners
     */
    account_owners: Array<string>;

    /**
     * Read-only SCIM 2.0 provisioning settings. Server-managed via scim_action; ignored if sent on create or update
     */
    scim_settings: models.MasterAccountScimSettings;

    /**
     * Write-only SCIM token lifecycle action. Accepted on update only; not part of create and never returned in responses
     */
    scim_action: models.MasterAccountScimAction;

}
